import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import api from "../api/api";

import {
  Box,
  Button,
  TextField,
  Typography,
  Paper,
  CircularProgress,
} from "@mui/material";

import LocalShippingIcon from "@mui/icons-material/LocalShipping";

const TrackingGood = () => {
  const [trackingCode, setTrackingCode] = useState("");
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const handleTrack = async () => {
    if (!trackingCode.trim()) {
      Swal.fire({
        icon: "warning",
        title: "Tracking Code Required",
        text: "Please enter your tracking code.",
      });
      return;
    }

    setLoading(true);

    try {
      const code = trackingCode.trim().toUpperCase();
      await api.get(`/good-shipments/track/?code=${code}`);
      navigate(`/tracking/${code}`);
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Invalid Tracking Code",
        text:
          error.response?.data?.error ||
          "Tracking information not found.",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        justifyContent: "center",
        px: 2,
        py: 2,
      }}
    >
      <Paper
        elevation={0}
sx={{
  width: "100%",
  maxWidth: { xs: "92%", sm: 450, md: 420, lg: 480 },
  p: 3,
  borderRadius: 3,
  border: "1px solid #e5e7eb",
  textAlign: "center",
  backgroundColor: "#fff",
}}
      >
        <LocalShippingIcon
          sx={{ fontSize: 60, color: "#f59e0b", mb: 2 }}
        />

        <Typography variant="h5" sx={{ fontWeight: "bold", mb: 1 }}>
          Track Shipment
        </Typography>

        <Typography sx={{ color: "#6b7280", mb: 3, fontSize: "0.9rem" }}>
          Enter your tracking code to see shipment progress.
        </Typography>

        <TextField
          fullWidth
          label="Tracking Code"
          value={trackingCode}
          onChange={(e) => setTrackingCode(e.target.value)}
          sx={{ mb: 3 }}
        />

        <Button
          fullWidth
          variant="contained"
          onClick={handleTrack}
          disabled={loading}
          sx={{
            py: 1.4,
            fontWeight: "bold",
            textTransform: "none",
            background: "linear-gradient(90deg, #f59e0b, #ea580c)",
          }}
        >
          {loading ? (
            <CircularProgress size={22} sx={{ color: "#fff" }} />
          ) : (
            "Track Shipment"
          )}
        </Button>
      </Paper>
    </Box>
  );
};

export default TrackingGood;

